<div class="placeholder-panel">
  <h2 class="placeholder-title">Customers</h2>
  <p class="placeholder-text">Coming soon — customer registration and management.</p>
</div>
